<template>
  <div style="background:#ECECEC">
    <div class="outer-container">
      <div class="ucontainer">
        <div class=" special_text">
          <h5 class="text-center manrope extrabold" style=" color:white">
            FOR JOB SEEKERS
          </h5>
        </div>

        <h2 class="text-center manrope heading_fonts">
          How can you become a part
          <br />
          of the Talent Pool of Upskill?
        </h2>

        <div class="grid" style="padding-top:30px">
          <div class="border-radius">
            <h3 class="manrope bold">Assessment Selection</h3>
            <p class="manrope ">
              Select the assessment test that matches your talent
            </p>
          </div>
          <div class="border-radius">
            <h3 class="manrope bold">Score > 60%</h3>
            <p class="manrope ">
              To be part of our pool, every candidate needs to score above 60%,
              but that doesn’t guarantee the employment. There will be further
              interviews
            </p>
          </div>
          <div class="border-radius">
            <h3 class="manrope bold">Get ready to be Hired</h3>
            <p class="manrope ">
              Once the recruiter chooses you for hire, you give us fee for
              placement services
            </p>
          </div>
        </div>
        <div class="home-hero__content-cta-1">
          <a href="#jobseeker" class=" hover  ">Get Started </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.home-hero__content-cta-1 {
  display: flex;
  justify-content: center;
  padding-top: 30px;
}
.home-hero__content-cta-1 a {
  font-family: 'Manrope', sans-serif;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 700;

  max-width: 260px;
  min-width: 240px;
  border-radius: 4px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 2px solid #2465f3;
}
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2%;
  color: #29292b;
}
.special_text {
  display: flex;

  justify-content: center;
  align-items: center;
}
.special_text h5 {
  display: inline-flex;
  background-color: #142f71;
  padding: 10px 50px;
  letter-spacing: 2px;
}
.outer-container {
  padding: 100px 0;
}
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2px;
  color: #29292b;
  padding-top: 12px;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  place-items: center;
  max-width: 964px;
  margin: 0 auto;
  grid-gap: 50px;
}
.grid > * {
  padding: 25px;
  background: white;
  min-height: 300px;
  max-width: 300px;
  min-width: 275px;
}
.grid > * h3 {
  color: #184dbd;
}
.grid > * p {
  padding-top: 10px;
  font-size: 16px;
}
@media (max-width: 767.98px) {
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    place-items: center;
  }
  .outer-container {
    padding: 50px 0;
  }
  .heading_fonts {
    font: 800 1.5rem/1.6rem 'Manrope';
    letter-spacing: 1px;
    color: #29292b;
  }
  .grid > * h2 {
    font-weight: 700;
    font-size: 1.5rem;
  }
  .grid > * {
    padding: 25px;
    background: white;
    max-width: 335px;
    min-height: 230px;
  }
}
</style>
